'use client';

import dynamic from 'next/dynamic';

import { useAlgoliaFailover } from '@/hooks/useAlgoliaFailover';

import AlgoliaAutoComplete from './AutoComplete';

const StrapiAutoComplete = dynamic(() => import('./StrapiAutoComplete'), { ssr: false });

type AutoCompeleteProps = {
  className?: string;
  containerClassName?: string;
  isDashboard?: boolean;
  isMobileDashboard?: boolean;
};

const AutoCompleteWrapper: React.FC<AutoCompeleteProps> = ({
  className,
  containerClassName,
  isDashboard,
  isMobileDashboard,
}) => {
  const { isAlgoliaDown } = useAlgoliaFailover();

  console.log('isAlgoliaDown', isAlgoliaDown);

  return (
    <>
      {isAlgoliaDown ? (
        <StrapiAutoComplete
          className={className}
          containerClassName={containerClassName}
          isDashboard={isDashboard}
          isMobileDashboard={isMobileDashboard}
        />
      ) : (
        <AlgoliaAutoComplete
          className={className}
          containerClassName={containerClassName}
          isDashboard={isDashboard}
          isMobileDashboard={isMobileDashboard}
        />
      )}
    </>
  );
};

export default AutoCompleteWrapper;
